// extracted by mini-css-extract-plugin
module.exports = {"container":"OutRecord_container_29fB_","title_tips":"OutRecord_title_tips_1gtTc","table_actions":"OutRecord_table_actions_ciOKR","btn":"OutRecord_btn_3r_0x"};